export const EVENT_JOB_START = 'job_start';
export const EVENT_JOB_COMPLETE = 'job_complete';
export const EVENT_JOB_FAIL = 'job_fail';
export const EVENT_JOB_INIT_SUCCESS = 'job_init_success'
export const EVENT_JOB_DELETE_INIT = 'job_delete_init';
export const EVENT_JOB_NOT_FOUND = 'job_not_found_event';
export const EVENT_JOB_SYS_SUCCESS = 'job_sys_success';
export const EVENT_JOB_SELECT_OUTPUT = 'job_sys_select_output';
export const EVENT_JOB_APPLY_IMAGE = 'job_apply';